import React, { useContext,useEffect } from 'react';
import { toast } from "react-toastify";
import { useHistory } from "react-router";
import { UserContext } from "../../context/UserContext";
const PayAborted = () => {
    const context = useContext(UserContext);
    let history = useHistory();
    useEffect(() => {
        context.setUser(null);
		localStorage.clear();
        toast.error("Your transaction has been cancled..", {
            position: toast.POSITION.BOTTOM_LEFT,
          });
          history.push({
            pathname: "/signin"
          });
      }, []);
    return (
        <div>
            
        </div>
    );
};

export default PayAborted;